import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeMethod } from "../core/base-api/methods-maker";
export var SeriesApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(SeriesApi, _BaseApi);

  var _super = _createSuper(SeriesApi);

  function SeriesApi() {
    _classCallCheck(this, SeriesApi);

    return _super.apply(this, arguments);
  }

  return SeriesApi;
}(BaseApi);
/**
 * list of available series
 */

SeriesApi.prototype.list = makeMethod({
  method: 'get',
  path: Request.Series.Paths.List
});
/**
 * series info
 */

SeriesApi.prototype.show = makeMethod({
  method: 'get',
  path: Request.Series.Paths.Show
});
/**
 * request videos for given series
 */

SeriesApi.prototype.listVideos = makeMethod({
  method: 'get',
  path: Request.Series.Paths.ListVideos
});
/**
 * return index of video of given video id in collection. based on order
 */

SeriesApi.prototype.findVideoIndex = makeMethod({
  method: 'get',
  path: Request.Series.Paths.FindVideoIndex
});
/**
 * list of available seasons for series
 */

SeriesApi.prototype.listSeasons = makeMethod({
  method: 'get',
  path: Request.Series.Paths.ListSeasons
});
/**
 * season info
 */

SeriesApi.prototype.showSeason = makeMethod({
  method: 'get',
  path: Request.Series.Paths.ShowSeason
});
/**
 * request videos for given series and season
 */

SeriesApi.prototype.listSeasonVideos = makeMethod({
  method: 'get',
  path: Request.Series.Paths.ListSeasonVideos
});
/**
 * return index of video of given video id in collection. based on order
 */

SeriesApi.prototype.findSeasonVideoIndex = makeMethod({
  method: 'get',
  path: Request.Series.Paths.FindSeasonVideoIndex
});